import { LinkedLinkProps } from 'shared-definitions/types'
import { externalLinkRegexp } from 'shared-code/regexp'
import { ApiObjectLink, ApiObjectLink2 } from 'data-source/types.wp'
import type { HTMLAttributeReferrerPolicy } from 'react'

type PostLinkBuilder = (slug: string) => LinkedLinkProps

export interface PLinkMapperOpts {
  postLinkBuilder: PostLinkBuilder
}

export function pLinkMapper(
  input: string | ApiObjectLink | ApiObjectLink2,
  opts: PLinkMapperOpts
): LinkedLinkProps {
  if (typeof input === 'string') {
    return mapString(input, opts)
  }

  return mapObject(input)
}

function mapObject(input: ApiObjectLink | ApiObjectLink2): LinkedLinkProps {
  if ('url' in input) {
    return {
      href: input.url,
      target: input.target,
      title: input.title,
    }
  }
  return {
    href: input.href,
    referrerPolicy: input.referrerpolicy as HTMLAttributeReferrerPolicy,
    target: input.target,
  }
}

function mapString(input: string, opts: PLinkMapperOpts): LinkedLinkProps {
  const external = externalLinkRegexp.test(input)
  if (external) {
    return pLinkExternalMapper(input)
  }

  return opts.postLinkBuilder(input)
}

export function pLinkExternalMapper(input: string): LinkedLinkProps {
  return {
    href: input,
    target: '_blank',
    rel: 'noreferrer nofollow',
  }
}
